import { DataTable } from "@components/DataTable/DataTable"
import { useChooseOffersListColumns } from "./utils/tableColumSchema"
import type { IOffer } from "@commonTypes/offer"

type TOffersSummaryProps = {
  data: IOffer[]
  isPending?: boolean
  title?: string
  requestId?: string
  includeEnroll?: boolean
}

export const OffersSummary = ({
  data,
  isPending,
  title,
  requestId,
  includeEnroll = true,
}: TOffersSummaryProps) => {
  const chooseOffersListColumns = useChooseOffersListColumns({ includeEnroll })

  return (
    <div className="tw:flex tw:flex-col">
      <h1 className="tw:text-lg">{title}</h1>
      <DataTable
        data={data}
        columns={chooseOffersListColumns}
        pending={isPending}
      />
      {requestId && (
        <span className="tw:text-xs tw:text-red-500">{`Request IDs: ${requestId}`}</span>
      )}
    </div>
  )
}
